<dx-scroll-view width="100%" height="100%" showScrollbar="onHover">
<div class="search-form-editor p-3">

    <div class="d-flex align-items-center gap-3 mb-3">
        <label class="fw-bold text-nowrap">{{ 'Formularauswahl' | translate }}</label>
        <dx-select-box [dataSource]="allSearchForms"
                       displayExpr="name"
                       [(value)]="selectedSearchForm"
                       placeholder="Suche auswählen..."
                       style="max-width: 300px; flex: 1;">
        </dx-select-box>
        <div class="d-flex gap-1">
            <dx-button id="addbutton"
                       icon="plus"
                       type="default"
                       stylingMode="text"
                       hint="{{ 'Neues Suchformular anlegen' | translate }}"
                       (onClick)="createNewSearchForm()">
            </dx-button>
            <dx-button *ngIf="selectedSearchForm"
                       icon="copy"
                       type="default"
                       stylingMode="text"
                       hint="{{ 'Suchformular duplizieren' | translate }}"
                       (onClick)="copySearchForm()">
            </dx-button>
            <dx-button *ngIf="selectedSearchForm"
                       icon="trash"
                       type="default"
                       stylingMode="text"
                       hint="{{ 'Suchformular löschen' | translate }}"
                       (onClick)="deleteSearchForm()">
            </dx-button>
        </div>
    </div>

    <div *ngIf="selectedSearchForm">
        <div class="d-flex align-items-center gap-3 mb-3">
            <label class="fw-bold text-nowrap">{{ 'Name' | translate }}</label>
            <dx-text-box
                [(value)]="selectedSearchForm.name"
                (onFocusOut)="saveSearchForm()"
                style="flex: 1;">
            </dx-text-box>
        </div>
        <div class="d-flex align-items-center gap-3 mb-3">
            <label class="fw-bold text-nowrap">{{ 'Kondition' | translate }}</label>
            <dx-radio-group [items]="possibleConditions"
                            valueExpr="key"
                            displayExpr="text"
                            [(value)]="selectedSearchForm.filterCondition"
                            (onValueChanged)="saveSearchForm()"
                            layout="horizontal">
            </dx-radio-group>
        </div>

        <div *ngIf="showValidationErrors" class="validation-warning d-flex align-items-center gap-2 mb-3">
            <i class="dx-icon-warning"></i>
            <div>
                <strong>{{ 'Suchformular enthält ungültige Einträge' | translate }}:</strong>
                <ul class="mb-0 mt-1">
                    <li *ngFor="let error of getValidationErrors()">{{ error }}</li>
                </ul>
            </div>
        </div>

        <div class="condition-grid border-top pt-3">
            <div class="search-grid search-grid-header text-muted small mb-1">
                <div></div>
                <div>{{ 'Gruppe' | translate }}</div>
                <div>{{ 'Feld' | translate }}</div>
                <div></div>
                <div></div>
                <div>{{ 'Operator' | translate }}</div>
                <div>{{ 'Werte' | translate }}</div>
                <div></div>
            </div>

            <dx-sortable
                filter=".condition-row"
                handle=".drag-handle"
                (onReorder)="onReorderSearchOptions($event)">
                <ng-container *ngFor="let row of selectedSearchForm?.searchOptions; let i = index; let last = last" >
                    <div class="condition-row search-grid mb-2 p-2 rounded shadow-sm"
                         [class.bg-light]="!showValidationErrors || isRowValid(row)"
                         [class.validation-error-row]="showValidationErrors && !isRowValid(row)">
                            <div class="drag-handle text-muted d-flex align-items-center" style="cursor: grab;">
                                <i class="dx-icon-dragvertical"></i>
                            </div>
                            <div>
                                <dx-select-box [items]="groups"
                                               [value]="getGroupForRow(row)"
                                               [displayExpr]="translateGroup"
                                               placeholder="{{ 'Auswählen...' | translate }}"
                                               (onValueChanged)="onGroupChanged($event, row)"
                                               itemTemplate="groupItem"
                                >
                                    <div *dxTemplate="let item of 'groupItem'" [title]="translateGroup(item)">
                                        {{ translateGroup(item) }}
                                    </div>
                                </dx-select-box>
                            </div>
                            <div>
                                <dx-select-box [items]="getFieldsForGroup(getGroupForRow(row))"
                                               [displayExpr]="getFieldDisplayExpr"
                                               valueExpr="field"
                                               placeholder="{{ 'Auswählen...' | translate }}"
                                               (onValueChanged)="onFieldChanged($event, row)"
                                               [(value)]="row.nextPimField.field"
                                               itemTemplate="fieldItem"
                                >
                                    <div *dxTemplate="let item of 'fieldItem'" [title]="getFieldDisplayExpr(item)">
                                        {{ getFieldDisplayExpr(item) }}
                                    </div>
                                </dx-select-box>
                            </div>
                            <div>
                                <dx-select-box *ngIf="isFeatureGroup(row) && needsSystem(row)"
                                               [items]="validFeatureSystems"
                                               valueExpr="id"
                                               displayExpr="name"
                                               placeholder="{{ 'Auswählen...' | translate }}"
                                               [showClearButton]="true"
                                               [searchEnabled]="true"
                                               [(value)]="row.nextPimField.systemKey"
                                               (onValueChanged)="onFeatureSystemChanged(row)"
                                               itemTemplate="systemItem"
                                >
                                    <div *dxTemplate="let item of 'systemItem'" [title]="item.name">
                                        {{ item.name }}
                                    </div>
                                </dx-select-box>
                            </div>
                            <div>
                                <dx-select-box *ngIf="isFeatureGroup(row) && needsElement(row) && row.nextPimField?.systemKey"
                                               [dataSource]="getFeaturesDataSource(row.nextPimField.systemKey)"
                                               valueExpr="id"
                                               [displayExpr]="featureDisplayExpr"
                                               placeholder="{{ 'Auswählen...' | translate }}"
                                               [showClearButton]="true"
                                               [searchEnabled]="true"
                                               [(value)]="row.nextPimField.elementKey"
                                               (onValueChanged)="saveSearchForm()"
                                               itemTemplate="featureItem"
                                >
                                    <div *dxTemplate="let item of 'featureItem'" [title]="featureDisplayExpr(item)">
                                        {{ featureDisplayExpr(item) }}
                                    </div>
                                </dx-select-box>
                            </div>
                            <div>
                                <dx-select-box [items]="getOperatorsForField(row.nextPimField?.field, getGroupForRow(row))"
                                               [displayExpr]="translateOperator"
                                               (onValueChanged)="onOperatorChanged($event, row)"
                                               [(value)]="row.operator"
                                               placeholder="{{ 'Auswählen...' | translate }}"
                                               itemTemplate="operatorItem"
                                >
                                    <div *dxTemplate="let item of 'operatorItem'" [title]="translateOperator(item)">
                                        {{ translateOperator(item) }}
                                    </div>
                                </dx-select-box>
                            </div>
                            <div>
                                <ng-container *ngIf="row.operator && !isNoValueOperator(row.operator)" [ngSwitch]="getDataTypeForRow(row)">

                                    <dx-text-box *ngSwitchCase="'string'"
                                                 [(value)]="row.value"
                                                 (onFocusOut)="saveSearchForm()"
                                                 placeholder="{{ 'Wert eingeben...' | translate }}">
                                    </dx-text-box>

                                    <ng-container *ngSwitchCase="'number'">
                                        <div *ngIf="isRangeOperator(row.operator)" class="d-flex gap-2 align-items-center">
                                            <dx-number-box [(value)]="row.value"
                                                           (onValueChanged)="saveSearchForm()"
                                                           placeholder="{{ 'Von' | translate }}"
                                                           style="flex: 1;">
                                            </dx-number-box>
                                            <span class="text-muted">–</span>
                                            <dx-number-box [(value)]="row.valueTo"
                                                           (onValueChanged)="saveSearchForm()"
                                                           placeholder="{{ 'Bis' | translate }}"
                                                           style="flex: 1;">
                                            </dx-number-box>
                                        </div>
                                        <dx-number-box *ngIf="!isRangeOperator(row.operator)"
                                                       [(value)]="row.value"
                                                       (onValueChanged)="saveSearchForm()"
                                                       placeholder="{{ 'Wert eingeben...' | translate }}">
                                        </dx-number-box>
                                    </ng-container>

                                    <ng-container *ngSwitchCase="'date'">
                                        <div *ngIf="isRangeOperator(row.operator)" class="d-flex gap-2 align-items-center">
                                            <dx-date-box [(value)]="row.value"
                                                         (onValueChanged)="saveSearchForm()"
                                                         type="date"
                                                         displayFormat="dd.MM.yyyy"
                                                         placeholder="{{ 'Von' | translate }}"
                                                         style="flex: 1;">
                                            </dx-date-box>
                                            <span class="text-muted">–</span>
                                            <dx-date-box [(value)]="row.valueTo"
                                                         (onValueChanged)="saveSearchForm()"
                                                         type="date"
                                                         displayFormat="dd.MM.yyyy"
                                                         placeholder="{{ 'Bis' | translate }}"
                                                         style="flex: 1;">
                                            </dx-date-box>
                                        </div>
                                        <dx-date-box *ngIf="!isRangeOperator(row.operator)"
                                                     [(value)]="row.value"
                                                     (onValueChanged)="saveSearchForm()"
                                                     type="date"
                                                     displayFormat="dd.MM.yyyy"
                                                     placeholder="{{ 'Datum wählen...' | translate }}">
                                        </dx-date-box>
                                    </ng-container>

                                    <ng-container *ngSwitchCase="'boolean'">
                                    </ng-container>

                                    <dx-text-box *ngSwitchDefault
                                                 [(value)]="row.value"
                                                 (onFocusOut)="saveSearchForm()"
                                                 placeholder="{{ 'Wert eingeben...' | translate }}">
                                    </dx-text-box>

                                </ng-container>
                                <span *ngIf="row.operator && isNoValueOperator(row.operator)" class="text-muted fst-italic small">
                                    {{ 'Kein Wert erforderlich' | translate }}
                                </span>
                            </div>
                            <div class="d-flex align-items-center">
                                <dx-button icon="trash"
                                           type="default"
                                           stylingMode="text"
                                           (onClick)="removeRow(i)">
                                </dx-button>
                            </div>
                        </div>

                        <div class="my-2">
                            <span class="badge bg-secondary px-3 py-2">
                                {{ selectedSearchForm.filterCondition | translate}}
                            </span>
                        </div>

                    </ng-container>
                </dx-sortable>

                <div class="mt-3 rightside">
                    <dx-button icon="plus"
                               stylingMode="contained"
                               (onClick)="addNewRow()">
                    </dx-button>
                </div>
        </div>
    </div>

</div>
</dx-scroll-view>
